import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

interface UseEntityRouterResult {
  entityId: string | undefined;
  navigateToEntity: (id: string | number) => void;
  navigateToList: () => void;
  isDetailView: boolean;
}

export function useEntityRouter(basePath: string): UseEntityRouterResult {
  const params = useParams();
  const navigate = useNavigate();
  
  // Extract entity ID from params based on the route pattern
  const entityIdKey = Object.keys(params).find(key => key.endsWith('Id'));
  const entityId = entityIdKey ? params[entityIdKey] : undefined;
  
  const navigateToEntity = (id: string | number) => {
    navigate(`${basePath}/${id}`);
  };
  
  const navigateToList = () => {
    navigate(basePath);
  };
  
  const isDetailView = Boolean(entityId);
  
  // Update browser title based on entity
  useEffect(() => {
    if (entityId) {
      const entityType = basePath.split('/').pop() || '';
      document.title = `${entityType.charAt(0).toUpperCase() + entityType.slice(1)} #${entityId} - Workforce Route Optimizer`;
    } else {
      const entityType = basePath.split('/').pop() || '';
      document.title = `${entityType.charAt(0).toUpperCase() + entityType.slice(1)} - Workforce Route Optimizer`;
    }
  }, [entityId, basePath]);
  
  return {
    entityId,
    navigateToEntity,
    navigateToList,
    isDetailView
  };
}

export default useEntityRouter;